import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function AboutSection() {
  const aboutCats = categories.slice(7, 12);

  return (
    <section className="py-20 md:py-28 bg-background-950">
      <div className="max-w-[1400px] mx-auto px-6 text-center">
        <p className="text-background-400 text-xs tracking-widest uppercase mb-6">About allchinabuy sheet</p>

        <h2 className="text-4xl md:text-5xl lg:text-6xl text-background-50 leading-tight max-w-3xl mx-auto"
          style={{ fontFamily: 'var(--font-heading)' }}
        >
          Curated China Products<br />
          Organized in Spreadsheets<br />
          For Global Sellers.
        </h2>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50 text-foreground-900 rounded-full text-sm font-semibold hover:bg-background-100 transition-all cursor-pointer whitespace-nowrap"
          >
            allchinabuy sheet
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 border border-background-500 text-background-200 rounded-full text-sm font-medium hover:border-background-300 hover:text-background-50 transition-all cursor-pointer whitespace-nowrap"
          >
            buy it now
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>

        <div className="mt-16 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
          {aboutCats.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex flex-col items-center gap-3 p-5 rounded-xl bg-background-900/50 hover:bg-background-800/50 transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-shopping-bag-3-line text-background-300 text-xl group-hover:text-background-100 transition-colors"></i>
              </div>
              <span className="text-background-300 text-xs font-medium group-hover:text-background-100 transition-colors whitespace-nowrap">{cat.name}</span>
            </a>
          ))}
        </div>

        {/* SEO content paragraph */}
        <div className="mt-16 max-w-2xl mx-auto">
          <p className="text-background-400 text-sm leading-relaxed">
            AllChinaBuySpreadsheet is the fastest way to find winning products from China suppliers. Instead of spending hours browsing marketplaces, you get ready-to-use spreadsheets with verified winning products, supplier insights, price-vs-profit analysis, and TikTok trending items — all updated weekly for serious dropshippers.
          </p>
        </div>
      </div>
    </section>
  );
}